import React, { FC, useState } from 'react'
import { IonPopover } from '@ionic/react'
import './index.scss'

interface IProps {
  message: string;
}

const CannotPayTip: FC<IProps> = ({ message }) => {
  const [popoverEvent, setPopoverEvent] = useState<any>()

  return (
    <>
      <i
        className='iconfont icon-info'
        data-cypid='cannotPayTipShow'
        onClick={(e) => {
          e.stopPropagation()
          setPopoverEvent(e)
        }}
      />
      <IonPopover
        cssClass='cannot-pay-tip-popover'
        event={popoverEvent}
        isOpen={!!popoverEvent}
        onDidDismiss={() => setPopoverEvent(undefined)}
      >
        {message}
        <div
          className='acknowledged'
          data-cypid='cannotPayTipHide'
          onClick={(e) => {
            e.stopPropagation()
            setPopoverEvent(undefined)
          }}
        >
          {i18n.t('pay.acknowledged')}
        </div>
      </IonPopover>
    </>
  )
}

export default CannotPayTip
